var map = {
	"./Office.png": 41,
	"./ae.svg": 42,
	"./au.svg": 43,
	"./barbell.png": 44,
	"./be.svg": 45,
	"./bike.png": 46,
	"./books.png": 47,
	"./ch.svg": 48,
	"./cheeseburger.png": 49,
	"./cn.svg": 50,
	"./cone.png": 51,
	"./construction.png": 52,
	"./cu.svg": 53,
	"./de.svg": 54,
	"./fr.svg": 55,
	"./gb.svg": 56,
	"./goals.png": 57,
	"./hk.svg": 58,
	"./hobbies.png": 59,
	"./honeybee.png": 60,
	"./ibm.png": 61,
	"./il.svg": 62,
	"./in.svg": 63,
	"./jm.svg": 64,
	"./laptop.png": 65,
	"./mailbox.png": 66,
	"./microphone.png": 67,
	"./mx.svg": 68,
	"./name.png": 69,
	"./nl.svg": 70,
	"./nz.svg": 71,
	"./plane.png": 72,
	"./shuttle.png": 73,
	"./surfboard.png": 74,
	"./sword.png": 75,
	"./target.png": 76,
	"./vn.svg": 77,
	"./vr.png": 78,
	"./za.svg": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;